import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_cave-hero-salon/artifacts/mz0y0jq3_WhatsApp_Image_2026-02-20_at_5.57.50_PM-removebg-preview.png";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#0A0A0A] border-t border-white/5">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <img
              src={LOGO_URL}
              alt="CAVE Men's Salon"
              className="h-12 w-auto object-contain mb-5"
            />
            <p className="text-[#525252] text-sm leading-relaxed">
              Structured grooming for men who care about how they look.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] mb-5 font-sans font-semibold">
              Navigate
            </h4>
            <div className="flex flex-col gap-3">
              {[
                { to: "/", label: "Home" },
                { to: "/about", label: "About" },
                { to: "/services", label: "Services" },
                { to: "/blog", label: "Blog" },
                { to: "/franchise", label: "Franchise" },
                { to: "/book", label: "Book Appointment" },
                { to: "/contact", label: "Contact" },
              ].map((l) => (
                <Link
                  key={l.to}
                  to={l.to}
                  className="text-[#A3A3A3] text-sm hover:text-[#E5E5E5] transition-colors"
                >
                  {l.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] mb-5 font-sans font-semibold">
              Contact
            </h4>
            <div className="flex flex-col gap-3 text-sm text-[#A3A3A3]">
              <a href="tel:+918867277374" className="flex items-center gap-2 hover:text-[#E5E5E5] transition-colors">
                <Phone className="w-3.5 h-3.5 text-[#D4AF37]" />
                +91 8867277374 (Koramangala)
              </a>
              <a href="tel:+917022116556" className="flex items-center gap-2 hover:text-[#E5E5E5] transition-colors">
                <Phone className="w-3.5 h-3.5 text-[#D4AF37]" />
                +91 7022116556 (Karkala)
              </a>
              <a href="tel:+916361405109" className="flex items-center gap-2 hover:text-[#E5E5E5] transition-colors">
                <Phone className="w-3.5 h-3.5 text-[#D4AF37]" />
                +91 6361405109
              </a>
              <a href="mailto:cavesalonindia@gmail.com" className="flex items-center gap-2 hover:text-[#E5E5E5] transition-colors">
                <Mail className="w-3.5 h-3.5 text-[#D4AF37]" />
                cavesalonindia@gmail.com
              </a>
            </div>
          </div>

          {/* Hours */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] mb-5 font-sans font-semibold">
              Hours
            </h4>
            <div className="flex flex-col gap-3 text-sm text-[#A3A3A3]">
              <div className="flex items-center gap-2">
                <Clock className="w-3.5 h-3.5 text-[#D4AF37]" />
                9:00 AM   9:30 PM
              </div>
              <p className="text-[#525252]">Tuesday Closed</p>
              <div className="flex flex-col gap-1 mt-1">
                <div className="flex items-center gap-2">
                  <MapPin className="w-3.5 h-3.5 text-[#D4AF37]" />
                  Koramangala, Bangalore
                </div>
                <div className="flex items-center gap-2">
                  <MapPin className="w-3.5 h-3.5 text-[#D4AF37] opacity-50" />
                  Karkala
                </div>
                <div className="flex items-center gap-2">
                  <MapPin className="w-3.5 h-3.5 text-[#D4AF37] opacity-50" />
                  Moodabidri
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-[#525252] text-xs">
            &copy; {new Date().getFullYear()} CAVE Men&apos;s Salon. All rights reserved.
          </p>
          <a
            href="https://instagram.com/cave.salonindia"
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs uppercase tracking-[0.15em] text-[#A3A3A3] hover:text-[#D4AF37] transition-colors"
          >
            @cave.salonindia
          </a>
        </div>
      </div>
    </footer>
  );
}
